import { writeFileSync, existsSync, mkdirSync, renameSync, openSync, writeSync, closeSync, constants } from 'fs'
import { dirname } from 'path'

export function atomicWriteJson(filePath: string, data: unknown): void {
  const dir = dirname(filePath)
  if (!existsSync(dir)) mkdirSync(dir, { recursive: true })
  const tmpPath = `${filePath}.tmp.${process.pid}.${Date.now()}`
  writeFileSync(tmpPath, JSON.stringify(data, null, 2) + '\n', 'utf-8')
  renameSync(tmpPath, filePath)
}

export function ensureDir(dirPath: string): void {
  if (!existsSync(dirPath)) mkdirSync(dirPath, { recursive: true })
}

export function appendLine(filePath: string, line: string): void {
  const dir = dirname(filePath)
  if (!existsSync(dir)) mkdirSync(dir, { recursive: true })
  const fd = openSync(filePath, constants.O_WRONLY | constants.O_APPEND | constants.O_CREAT, 0o644)
  try {
    writeSync(fd, line + '\n', null, 'utf-8')
  } finally {
    closeSync(fd)
  }
}
